import React, { useEffect } from 'react'
import mainImg from "../Assets/aboutImg1.webp"
import mainimg2 from "../Assets/aboutImg2.webp"
import bgAboutImg from "../Assets/aboutbgImg.webp"
import Aos from "aos"
export default function CommonAbout() {
  useEffect(() => {
    document.addEventListener("DOMContentLoaded" , () => {
      setTimeout(() => {
        Aos.refresh();
      },500)
    })
    Aos.init({duration:1000});
  },[])
  return (
    <>
      <div className="aboutSection anchor-point" >
        <div className="leftBlock">
            <figure className='BossImg'>
                <img src={mainImg} alt="" />
            </figure>

            <figure className="bgImg">
                <img src={bgAboutImg} alt="" />
            </figure>
            <figure className="mainImg2">
                <img src={mainimg2} alt="" />
            </figure>
            <div className="shortSlogan" data-aos="fade-right"  data-aos-offset="200" >
                <span>27</span>YEARS EXPERIENCE
            </div>

            {/* NewSp BLock */}

        </div>

        <div className="newSpBlock">
              <figure className="darkPic1">
              <img src={mainImg} alt="" />
              </figure>
              <div className="underSlogan">
            <div className="redCode" data-aos="fade-right" data-aos-offset="200" >
                <span>27</span>YEARS EXPERIENCE
            </div>
            </div>
              <figure className="darkPic2">
              <img src={mainimg2} alt="" />
              </figure>
            </div>

        <div className="rightBlock">
            <h2>About Us</h2>
            <h1>Reasons to choose</h1>
            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages </p>
            <p>It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
            <button>LEARN MORE</button>
        </div>
      </div>
    </>
  )
}
